import gql from 'graphql-tag';

export const ListOptionSetsQuery = gql`
  query ListOptionSetsQuery($name: String) {
    optionSets (name: $name) {
      name
      displayName
      logicalName
      options {
          label
          value
      }
    }
  }
`;

